// Agrupación por producto de la grilla de resultados del Catálogo IA.
//
// El flujo arma `productToImageIds` (producto → imágenes) al terminar la tanda y
// lo manda por navigation-state; la grilla lo invierte para saber, imagen por
// imagen, bajo qué header va.
//
// Vive acá afuera —y no inline en `GeneratedImagesInline`— porque su bug es
// silencioso: si la resolución falla, la grilla NO se rompe, simplemente deja de
// mostrar los separadores. Eso pasó (ver `catalogoAgrupacion.test.ts`) y nadie se
// enteró hasta que lo reportó un usuario. Como unidad pura, se testea.
//
// **Las claves se normalizan a string SIEMPRE.** `imagenes_generadas.id` es uuid,
// pero los ids viajan como `number | string` por el resto de la app (hay flujos
// viejos con ids numéricos). Un `Number('<uuid>')` da NaN y hace desaparecer la
// agrupación entera sin un solo error en consola.

export type IdImagen = number | string;

/** Invierte `producto → imágenes` en `imagen → producto`, con claves normalizadas. */
export function mapaImagenAProducto(
  productToImageIds?: Record<string, IdImagen[]> | null,
): Record<string, string> {
  const mapa: Record<string, string> = {};
  if (!productToImageIds) return mapa;
  for (const [productoId, imagenes] of Object.entries(productToImageIds)) {
    for (const imagenId of imagenes ?? []) {
      mapa[String(imagenId)] = productoId;
    }
  }
  return mapa;
}

/** Producto al que pertenece una imagen, o null si no está en el mapa. */
export function productoDeImagen(
  mapa: Record<string, string>,
  imagenId: IdImagen,
): string | null {
  return mapa[String(imagenId)] ?? null;
}
